var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIconUserMapping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 174898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3168 4.79726L9.24275 12.8712C8.43873 13.6753 6.05205 14.0476 5.51886 13.5145C4.98567 12.9813 5.34959 10.5946 6.15361 9.79059L14.2361 1.70812C14.4354 1.49066 14.6767 1.31586 14.9455 1.19424C15.2142 1.07262 15.5049 1.0067 15.7998 1.00048C16.0947 0.994279 16.3878 1.04789 16.6615 1.15809C16.9351 1.26829 17.1836 1.43282 17.3918 1.64169C17.6001 1.85057 17.764 2.09947 17.8734 2.3734C17.9828 2.64733 18.0357 2.94058 18.0287 3.23549C18.0217 3.53039 17.9549 3.82085 17.8326 4.08926C17.7102 4.35768 17.5348 4.59854 17.3168 4.79726Z",
    stroke: "#3B7FFC",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.617 2.76599H4.38533C3.48748 2.76599 2.62647 3.12265 1.99159 3.75753C1.35672 4.39241 1 5.25348 1 6.15133V14.6147C1 15.5125 1.35672 16.3736 1.99159 17.0084C2.62647 17.6434 3.48748 18 4.38533 18H13.695C15.5654 18 16.234 16.4766 16.234 14.6147V10.383",
    stroke: "#3B7FFC",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconUserMapping);
export default __webpack_public_path__ + "static/media/editIconUser-Mapping.2b33035090cfcd4cd298a0bed86d56c5.svg";
export { ForwardRef as ReactComponent };